module.exports = __webpack_public_path__ + "static/media/draft.5ff3cad9.svg";